import {
  Pickaxe,
  Coffee,
  HardHat,
  Tractor,
  HeartPulse,
  Laptop,
  ShoppingBag,
  Truck,
  MoreHorizontal,
} from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const VISA_OPTIONS = ["417", "462", "482", "494", "500", "PR", "Citizen", "Other"];

export const SECTOR_OPTIONS = [
  { key: "mining", icon: Pickaxe },
  { key: "hospitality", icon: Coffee },
  { key: "construction", icon: HardHat },
  { key: "farm", icon: Tractor },
  { key: "healthcare", icon: HeartPulse },
  { key: "tech", icon: Laptop },
  { key: "retail", icon: ShoppingBag },
  { key: "logistics", icon: Truck },
  { key: "other", icon: MoreHorizontal },
];

// State pill color mapping (used in CityAutocomplete)
export const STATE_COLORS = {
  WA: "#D95D39",
  NSW: "#2A5C5A",
  VIC: "#E5A93D",
  QLD: "#3B8268",
  SA: "#9B5DE5",
  TAS: "#3D7BB5",
  NT: "#C24F2E",
  ACT: "#57534E",
};
